<div class="markdown-container">
  <markdown [data]="renderedMarkdown"></markdown>
</div>
